import { render, staticRenderFns } from "./base.vue?vue&type=template&id=c8e2502c&scoped=true&"
var script = {}
import style0 from "./base.vue?vue&type=style&index=0&id=c8e2502c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e2502c",
  null
  
)

export default component.exports